import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@/context/AuthContext';
import { request } from '@/lib/utils';
import type { UserProfile } from '@/context/UserType';

const useUserProfile = () => {
  const { token } = useAuth();
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUserProfile = useCallback(async () => {
    if (!token) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const data: UserProfile = await request('/user/profile');
      setUserProfile(data);
    } catch (err) {
      console.error('Failed to fetch user profile:', err);
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      setUserProfile(null);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  return { userProfile, isLoading, error, refetchUserProfile: fetchUserProfile };
};

export default useUserProfile;
